var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M31.356 16.353c0-1.315-.107-2.275-.338-3.27h-15.02v5.937h8.816c-.177 1.475-1.137 3.697-3.27 5.19l-.03.199 4.749 3.679.329.033c3.022-2.791 4.764-6.897 4.764-11.768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M15.998 31.996c4.32 0 7.945-1.422 10.594-3.875l-5.048-3.911c-1.351.942-3.164 1.6-5.546 1.6-4.23 0-7.821-2.79-9.101-6.648l-.188.016L1.771 23l-.065.18c2.631 5.225 8.035 8.816 14.292 8.816z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M6.897 19.162c-.338-.995-.533-2.062-.533-3.164 0-1.102.195-2.169.515-3.164l-.009-.212-5-3.883-.164.078C.622 10.985 0 13.42 0 15.997c0 2.578.622 5.014 1.706 7.182l5.19-4.017z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M15.998 6.186c3.004 0 5.03 1.297 6.186 2.382l4.515-4.409C23.926 1.582 20.317 0 15.998 0 9.74 0 4.338 3.59 1.706 8.817l5.173 4.017c1.298-3.857 4.888-6.648 9.119-6.648z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h31.356v31.996H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c0e10d6cd4f2de9ef2d18c784ef9580d.svg";
export { ForwardRef as ReactComponent };